var _path, _path2, _path3, _rect;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M24.0003 37.3464C31.3641 37.3464 37.3337 31.3768 37.3337 24.013C37.3337 16.6492 31.3641 10.6797 24.0003 10.6797C16.6365 10.6797 10.667 16.6492 10.667 24.013C10.667 31.3768 16.6365 37.3464 24.0003 37.3464Z",
    fill: "#00468A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24 17.2529C21.24 17.2529 19 19.4929 19 22.2529C19 24.9596 21.12 27.1596 23.9333 27.2396C23.9733 27.2396 24.0267 27.2396 24.0533 27.2396C24.08 27.2396 24.12 27.2396 24.1467 27.2396C24.16 27.2396 24.1733 27.2396 24.1733 27.2396C26.8667 27.1463 28.9867 24.9596 29 22.2529C29 19.4929 26.76 17.2529 24 17.2529Z",
    fill: "#00468A"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M33.04 33.8136C30.6667 36.0003 27.4934 37.347 24 37.347C20.5067 37.347 17.3334 36.0003 14.96 33.8136C15.28 32.6003 16.1467 31.4936 17.4134 30.6403C21.0534 28.2136 26.9734 28.2136 30.5867 30.6403C31.8667 31.4936 32.72 32.6003 33.04 33.8136Z",
    fill: "#00468A"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 47,
    height: 47,
    rx: 23.5,
    stroke: "#E9E9E9",
    strokeOpacity: 0.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/user.347c44402fff48e14b9388326de845c1.svg";
export { ForwardRef as ReactComponent };